import { Historiquetache } from './../models/historiqueTache.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { throwError } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'access_token',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class HistoTacheService {
    baseUrl: string = environment.apiUrl;

    constructor(private httpClient: HttpClient) { }

    get_histotaches() {
        return this.httpClient.get(this.baseUrl + '/histotache');
    }
    createHistotaches(histoTache: Historiquetache) {
      return this.httpClient.post<Historiquetache>(this.baseUrl + '/histotaches/create', histoTache, httpOptions)
      .catch((error: any) => {;
        return throwError(error);
      });
    }

}